import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentinpune() {



const cardData = {
  keyword: "Mini Bus On Rent in Pune  ",

"headingDescription": "SRS Cab Service offers Mini Bus On Rent in Pune, providing spacious, comfortable, and reliable travel for large groups, corporate outings, school trips, and family excursions. Our well-maintained mini buses, experienced drivers, and timely service ensure a smooth and hassle-free journey across Pune and nearby destinations. With flexible booking options, transparent fares, and 24/7 customer support, SRS Cab Service makes group travel convenient, safe, and enjoyable.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort and a major landmark in Pune. Travelers renting a Mini Bus from SRS Cab Service often include this site in their itinerary to explore Maratha architecture and Pune’s cultural heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an important historical monument associated with India’s freedom struggle. Groups traveling with SRS Cab Service often stop here to admire the gardens and museum exhibits."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is renowned for its scenic hill views and trekking opportunities. Travelers renting a Mini Bus from SRS Cab Service frequently plan a visit for adventure and sightseeing."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered religious sites. Groups using SRS Cab Service often stop here to experience spiritual serenity and local traditions."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine dedicated to Lord Shiva. Travelers renting a Mini Bus from SRS Cab Service enjoy its historic charm and peaceful ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses an extensive collection of Indian artifacts. Groups using SRS Cab Service explore Pune’s cultural and artistic heritage here."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple offers panoramic views of Pune along with historic temples. Travelers renting a Mini Bus from SRS Cab Service often climb the hill for sightseeing and leisure."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a peaceful destination surrounded by water and hills. Groups using SRS Cab Service often include this spot in their itinerary for relaxation and photography."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden is a Japanese-style landscaped park ideal for calm walks. Travelers renting a Mini Bus from SRS Cab Service enjoy its lush greenery and serene environment."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic palace associated with Chhatrapati Shivaji Maharaj. Groups using SRS Cab Service often visit this landmark to learn about Pune’s rich history and heritage."
  }
],



services: [
{
name: "Mini Bus Hire in Pune",
description: "Mini bus hire in Pune offers convenient group travel for events and tours. Customers can book buses for family and corporate trips. Professional drivers ensure safe journeys. Comfortable seating enhances travel experience. Flexible booking options are available. Travel easily with mini bus hire services in Pune."
},
{
name: "Mini Bus Hire Pune",
description: "Mini bus hire Pune provides reliable transportation for group travel needs. Customers can book buses for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Choose mini bus hire services in Pune easily."
},
{
name: "Mini Bus Rental Pune",
description: "Mini bus rental Pune offers flexible vehicle options for group transportation. Customers can rent buses for tours and events. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Transparent pricing ensures affordability. Rent mini buses easily in Pune."
},
{
name: "Mini Bus Service in Pune",
description: "Mini bus service in Pune provides dependable travel for group transportation. Customers can book buses for daily and event travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with mini bus services in Pune."
},
{
name: "Pune Mini Bus Rental",
description: "Pune mini bus rental offers convenient travel solutions for groups. Customers can rent buses for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with mini bus rentals."
},
{
name: "Mini Bus Booking Pune",
description: "Mini bus booking Pune provides quick and easy reservation options. Customers can book buses online or offline. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Book mini buses easily in Pune."
},
{
name: "Mini Bus in Pune",
description: "Mini bus in Pune offers reliable transportation for group travel. Customers can book buses for events and tours. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with mini bus services in Pune."
},
{
name: "Affordable Mini Bus Pune",
description: "Affordable mini bus Pune provides budget-friendly travel for groups. Customers can book buses at competitive prices. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Transparent pricing ensures affordability. Travel easily with affordable mini bus services."
},
{
name: "Luxury Mini Bus Pune",
description: "Luxury mini bus Pune offers premium travel experience for groups. Customers can enjoy high-end buses with extra comfort. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel comfortably with luxury mini bus services."
},
{
name: "Corporate Mini Bus Pune",
description: "Corporate mini bus Pune provides reliable transportation for office travel. Companies can book buses for employee transport. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with corporate mini bus services."
},
{
name: "Pune to Shirdi Mini Bus on Rent",
description: "Pune to Shirdi mini bus on rent offers comfortable travel for pilgrimage trips. Customers can book buses for group darshan tours. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Shirdi with mini bus services."
},
{
name: "Pune to Mahabaleshwar Mini Bus on Rent",
description: "Pune to Mahabaleshwar mini bus on rent offers convenient travel for hill station trips. Customers can book buses for group outings. Professional drivers ensure safe ghat road journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Mahabaleshwar."
},
{
name: "Pune to Mumbai Mini Bus on Rent",
description: "Pune to Mumbai mini bus on rent provides reliable intercity travel for groups. Customers can book buses for business and leisure trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily from Pune to Mumbai."
},
{
name: "Pune to Mumbai Airport Mini Bus on Rent",
description: "Pune to Mumbai airport mini bus on rent offers group airport transfer services. Customers can book buses for convenient travel. Professional drivers ensure timely journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Mumbai Airport with mini bus services."
},
{
name: "Mini Bus Rentals",
description: "Mini bus rentals provide flexible travel options for group transportation. Customers can book buses for events and tours. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Transparent pricing ensures affordability. Travel easily with mini bus rental services."
},
{
name: "Small Bus Rental",
description: "Small bus rental offers convenient travel for small groups and families. Customers can book compact buses for short and long trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with small bus rentals."
},
{
name: "25 Seater Minibus",
description: "25 seater minibus provides spacious travel for medium-sized groups. Customers can book buses for tours and corporate events. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with 25 seater minibuses."
},
{
name: "Mini Coach Bus Rental",
description: "Mini coach bus rental offers premium group travel with extra comfort. Customers can book buses for long-distance journeys. Professional drivers ensure safe travel. Spacious seating enhances experience. Flexible booking options are available. Travel easily with mini coach bus services."
},
{
name: "Pune to Goa Mini Bus on Rent",
description: "Pune to Goa mini bus on rent offers comfortable travel for beach trips. Customers can book buses for group vacations. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Goa with mini bus services."
},
{
name: "14 Seater Mini Bus on Rent",
description: "14 seater mini bus on rent provides compact group travel solutions. Customers can book buses for small group trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with 14 seater mini buses."
},
{
name: "Mini Bus on Hire in Pune SRS Cab Service",
description: "Mini bus on hire in Pune SRS cab service offers reliable transportation for groups. Customers can book buses for tours and events. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with SRS mini bus services."
},
{
name: "Luxury Bus on Rent in Pune",
description: "Luxury bus on rent in Pune offers premium travel for large groups. Customers can enjoy high-end buses with extra comfort. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel comfortably with luxury bus services."
},
{
name: "Mini Bus on Rent for Corporate Events",
description: "Mini bus on rent for corporate events provides reliable group transportation. Companies can book buses for meetings and events. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with corporate mini bus services."
},
{
name: "Mini Bus Price per km Pune",
description: "Mini bus price per km Pune provides detailed pricing for travel planning. Customers can check rates before booking buses. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Choose mini bus services with transparent pricing."
},
{
name: "Mini Bus Booking Online Pune",
description: "Mini bus booking online Pune offers instant reservation options for customers. Users can book buses digitally with ease. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Book your mini bus online easily."
},
{
name: "Mini Bus for Group Travel Pune",
description: "Mini bus for group travel Pune offers convenient transportation for group trips. Customers can book buses for tours and outings. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with group mini bus services."
},
{
name: "Mini Bus for Tour Pune",
description: "Mini bus for tour Pune provides reliable transportation for sightseeing trips. Customers can book buses for travel tours. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tour mini bus services."
},
{
name: "Mini Bus for Trip Pune",
description: "Mini bus for trip Pune offers convenient travel for family and group outings. Customers can book buses for short and long trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with mini bus trip services."
},
{
name: "Mini Bus for Outstation Pune",
description: "Mini bus for outstation Pune provides reliable travel for long-distance journeys. Customers can book buses for tours and events. Professional drivers ensure safe highway travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with outstation mini bus services."
},
{
name: "Mini Bus for Family Trip Pune",
description: "Mini bus for family trip Pune offers comfortable travel for family outings. Customers can book buses for vacations and tours. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with family mini bus services."
}
],

tableData: [
["Mini Bus Hire in Pune","Mini Bus Hire Pune"],
["Mini Bus Rental Pune","Mini Bus Service in Pune"],
["Pune Mini Bus Rental","Mini Bus Booking Pune"],
["Mini Bus in Pune","Affordable Mini Bus Pune"],
["Luxury Mini Bus Pune","Corporate Mini Bus Pune"],
["Pune to Shirdi Mini Bus on Rent","Pune to Mahabaleshwar Mini Bus on Rent"],
["Pune to Mumbai Mini Bus on Rent","Pune to Mumbai Airport Mini Bus on Rent"],
["Mini Bus Rentals","Small Bus Rental"],
["25 Seater Minibus","Mini Coach Bus Rental"],
["Pune to Goa Mini Bus on Rent","14 Seater Mini Bus on Rent"],
["Mini Bus on Hire in Pune SRS Cab Service","Luxury Bus on Rent in Pune"],
["Mini Bus on Rent for Corporate Events","Mini Bus Price per km Pune"],
["Mini Bus Booking Online Pune","Mini Bus for Group Travel Pune"],
["Mini Bus for Tour Pune","Mini Bus for Trip Pune"],
["Mini Bus for Outstation Pune","Mini Bus for Family Trip Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Ideal for Group Travel in Pune",
    WhyChoosedescription: "SRS Cab Service offers mini bus on rent in Pune, perfect for family trips, school outings, corporate events, and group travel with comfortable seating."
  },
  {
    WhyChooseheading: "Affordable Mini Bus Rental Pricing",
    WhyChoosedescription: "We provide budget-friendly mini bus rental in Pune with transparent pricing. Rates typically start from ₹18 to ₹28 per km depending on seating capacity and trip type."
  },
  {
    WhyChooseheading: "Multiple Seating Capacity Options",
    WhyChoosedescription: "Choose from 20, 25, 30, and 32 seater mini buses suitable for medium to large groups, ensuring comfortable travel for all passengers."
  },
  {
    WhyChooseheading: "AC & Non-AC Mini Bus Options",
    WhyChoosedescription: "We offer both AC and non-AC mini bus options equipped with comfortable seating, making travel convenient for different budgets."
  },
  {
    WhyChooseheading: "24/7 Mini Bus Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for mini bus bookings in Pune, allowing flexible travel planning for any time of the day."
  },
  {
    WhyChooseheading: "Perfect for Outstation & Events",
    WhyChoosedescription: "Our mini buses are ideal for Pune to Mahabaleshwar, Lonavala, Shirdi, Goa trips, as well as weddings, corporate events, and school picnics."
  },
  {
    WhyChooseheading: "Professional Drivers for Safe Travel",
    WhyChoosedescription: "We provide experienced drivers trained for city and highway routes, ensuring safe, smooth, and stress-free group travel."
  },
  {
    WhyChooseheading: "Trusted Mini Bus Rental Service in Pune",
    WhyChoosedescription: "SRS Cab Service is trusted for mini bus on rent in Pune due to reliable service, clean vehicles, and comfortable group travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide mini bus on rent in Pune?", answer: "Yes, SRS Cab Service offers mini bus rental in Pune for local and outstation travel." },
  { question: "What is the price of mini bus per km in Pune?", answer: "Mini bus rental in Pune typically starts from ₹18 to ₹28 per km depending on seating and type." },
  { question: "Which seating options are available in mini bus?", answer: "We provide 20, 25, 30, and 32 seater mini buses." },
  { question: "Is mini bus available for outstation trips?", answer: "Yes, mini buses are ideal for outstation travel like Mahabaleshwar, Lonavala, Shirdi, Goa, and more." },
  { question: "Do you provide AC mini buses?", answer: "Yes, we provide both AC and non-AC mini bus options." },
  { question: "Is mini bus available for weddings and corporate events?", answer: "Yes, mini buses are perfect for weddings, corporate events, and group travel." },
  { question: "Is mini bus available 24/7?", answer: "Yes, our service operates 24 hours a day for flexible booking." },
  { question: "Can I book mini bus online?", answer: "Yes, you can easily book mini bus on rent in Pune online or via phone." },
  { question: "Are drivers professional?", answer: "Yes, all our drivers are experienced and trained for group travel." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all mini buses are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Jadhav",
    feedback:
      "Booked mini bus from SRS Cab Service for school trip. Very comfortable and safe journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Pooja Kulkarni",
    feedback:
      "Best mini bus rental in Pune. Clean vehicle, professional driver, and great service.",
    rating: 5
  }
];































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus On Rent in Pune | SRS Cab",
  "description": "SRS Cab offers mini bus on rent in Pune for corporate events, family trips, and outstation travel. Hire affordable and luxury mini buses for Pune to Shirdi, Mahabaleshwar, Mumbai, and Mumbai Airport. Enjoy safe, comfortable, and reliable rides with 24x7 online booking and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      <Helmet>
  <title>Mini Bus On Rent in Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Hire mini bus on rent in Pune with SRS Cab. Affordable and luxury mini buses for corporate events, family trips, and outstation travel to Shirdi, Mahabaleshwar, Mumbai, and Mumbai Airport. 24x7 online booking with professional drivers." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/37.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Minibusonrentinpune;